import styled from 'styled-components';

export const LoaderPadding = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  padding-left: 2rem;
`;
